import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import styled from 'styled-components/native';

import { ScrollableContainer } from 'components/Containers';
import { Text } from 'components/Text';
import { UniversalButton } from 'components/UniveralButtons';

export const Container = styled(SafeAreaView)`
  flex: 1;
  background-color: ${({ theme }) => theme.color.white};
  padding-left: 24px;
  padding-right: 24px;
`;

export const Title = styled<typeof Text>(Text)`
  font-size: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.overlay.primary};
  text-align: center;
  margin-bottom: 28px;
`;

export const OptionsContainer = styled(View)`
  flex-direction: column;
`;

export const Option = styled.TouchableOpacity<{ selected: boolean }>`
  height: 69px;
  flex-direction: row;
  align-items: center;
  padding-left: 25px;
  padding-right: 25px;
  margin-bottom: 8px;
  border-radius: 8px;
  border-width: ${({ selected }) => (selected ? 2 : 1)}px;
  border-color: ${({ selected, theme }) =>
    selected ? theme.color.overlay.primary : theme.color.inputOutlineGrey};
  background-color: ${({ theme }) => theme.color.white};
`;

export const CheckCircle = styled(View)<{ selected: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  border-width: 2px;
  border-color: ${({ theme }) => theme.color.overlay.primary};
  background-color: ${({ selected, theme }) =>
    selected ? theme.color.overlay.primary : theme.color.white};
  align-items: center;
  justify-content: center;
  margin-right: 15px;
`;

export const CheckMark = styled<typeof Text>(Text)`
  color: ${({ theme }) => theme.color.white};
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
`;

export const OptionText = styled<typeof Text>(Text)`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.overlay.primary};
  line-height: 18px;
`;

export const ContinueButton = styled(UniversalButton)`
  margin-top: 24px;
  padding-left: 56px;
  padding-right: 56px;
  border-radius: 50px;
  align-self: center;
`;

export const NHSScrollWrapper = styled(ScrollableContainer)`
  flex: 1;
  width: 100%;
`;
